import React from "react";

export default function InputMeasurement({
  defaultValue,
  onChange,
  required,
  ...props
}) {
  const handleChange = (e) => {
    const val = e.target.value;
    // Only allow numbers and decimals
    if (/^\d*\.?\d*$/.test(val)) {
      onChange(val); // send as string instead of parseFloat
    }
  };

  return (
    <input
      type="number"
      step="any"
      defaultValue={defaultValue}
      onChange={handleChange}
      required={required}
      className="form-control"
      {...props}
    />
  );
}
